import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import Pagination from "../../components/Pagination/Pagination";
import { addStudyClaimRequest, getPanelListCompletedData } from "./MyReferralPage.api";
import { useEffect, useState } from "react";
import { Survey } from "../../components/MySurveys/MySurveys.interface";
import { points } from "./Redeem.fun";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { reqDataIntialState } from "./MyReferralPage.interface";
import { VirtualBalance } from "../../pages/MySurveysPg/MySurveysPg.api";
import LoadingOverlay from "react-loading-overlay-ts";
import { Modal } from "antd";
import { FiArrowRight, FiClipboard } from "react-icons/fi";
import { Badge, Card, EmptyState, PageHeader } from "components/ui";
const { confirm } = Modal;

type reqDataType = typeof reqDataIntialState;
// type DataType = typeof DataIntialState;

export const ClaimStudyData = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const navigate: NavigateFunction = useNavigate();
  const [checked, setChecked] = useState<boolean>(false);
  // const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [reqData, setReqData] = useState<reqDataType>(reqDataIntialState);
  // const [data, setData] = useState<DataType>(DataIntialState);
  const [claimData, setClaimData] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [walletCreatedDate, setWalletCreatedDate] = useState<any>("");

  const getVirtualBalanceBalance = useMutation(["balance"], () => VirtualBalance(auth.panelistId), {
    onSuccess: (response: any) => {
      if (response?.walletCreatedAt) {
        setWalletCreatedDate(response.walletCreatedAt);
      }
    },
  });

  const getPanelListData = useQuery(
    ["panel", reqData?.type],
    () => {
      return getPanelListCompletedData(
        auth.panelistId,
        currentPage,
        walletCreatedDate,
        reqData.type
      );
    },
    {
      enabled: !!walletCreatedDate,
      refetchOnWindowFocus: false,
    }
  );
  const studyClaimRequest = useMutation(
    ["claim"],
    (requestData: any) => addStudyClaimRequest(requestData),
    {
      onSuccess: (response: any) => {
        if (response.success) {
          Modal.success({
            title: "Success!",
            content: response.message,
          });
          getPanelListData.refetch();
        } else {
          Modal.error({
            title: "Encountered an error!",
            content: response.message,
          });
        }
      },
      onError: () => {
        Modal.error({
          title: "Encountered an error!",
          content: "something went wrong",
        });
      },
    }
  );

  const handleCheckboxChange = (event) => {
    setSelectedValues(
      selectedValues.reduce((acc, current) => {
        if (event.target.value === current) {
          return acc;
        } else {
          return [...acc, event.target.value];
        }
      }, [])
    );
  };

  useEffect(() => {
    if (walletCreatedDate) {
      getPanelListData.remove();
      getPanelListData.refetch();
    }
  }, [currentPage]);
  useEffect(() => {
    if (auth.isVirtualWalletOpen) {
      getVirtualBalanceBalance.mutate();
    } else {
      setWalletCreatedDate(auth.date);
    }
  }, []);

  function sendStudyClaimRequest(survey: Survey) {
    confirm({
      title: "Alert!",
      icon: <ExclamationCircleFilled />,
      content: "Are you sure you want to claim this study?",
      onOk() {
        const pointsData = survey.points ? points(survey.points, 0) : points(0, survey.vendorCpi);
        studyClaimRequest.mutate({
          panelListId: auth.panelistId,
          studyId: survey.sid,
          points: pointsData,
          p_id: survey.p_id,
        });
      },
    });
  }
  function btnNeeded(survey: Survey, type: string) {
    let btn;
    if (type === "surveys") {
      btn = (
        <>
          <a onClick={() => sendStudyClaimRequest(survey)} className="cursor-pointer zs-btn zs-btn-primary zs-btn-sm">
            {t("page.unsubscribe.Request")}
          </a>
        </>
      );
      if (survey.isRequested) {
        btn = (
          <>
            <Badge tone="warning" dot>
              {t("page.unsubscribe.pen")}
            </Badge>
          </>
        );
      }
      return btn;
    } else if (type === "reject") {
      btn = (
        <>
          <Badge tone="danger" dot>
            {t("page.unsubscribe.Rejected")}
          </Badge>
          {survey.rejectReason && (
            <p className="mt-1 text-xs text-left whitespace-normal text-danger">Reason: {survey.rejectReason}</p>
          )}
        </>
      );
      return btn;
    } else if (type === "approved") {
      btn = (
        <>
          <Badge tone="success" dot>
            {t("page.unsubscribe.Approved")}
          </Badge>
        </>
      );
      return btn;
    }
  }

  const tabs = [
    { value: "surveys", label: t("page.referral.Completed") },
    { value: "approved", label: t("page.referral.Approved") },
    { value: "reject", label: t("page.referral.Rejected") },
  ];
  const columnCount = reqData.type === "approved" ? 6 : 5;

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
          background: "rgb(var(--zs-overlay) / 0.45)",
        }),
      }}
      active={getPanelListData.isLoading || studyClaimRequest.isLoading}
      spinner
      text={t("claim.card.Loading")}
    >
      <div className="zs-page">
        <PageHeader
          eyebrow="Rewards"
          title={t("page.referral.Reward1")}
          subtitle="Request points for completed studies and track each request through review."
        />

        <Card flush>
          <div className="zs-table-toolbar">
            <div className="w-full overflow-x-auto sm:w-auto zs-scroll">
              <div className="flex min-w-max zs-segmented" role="tablist" aria-label="Study status">
                {tabs.map((tab) => (
                  <button
                    key={tab.value}
                    type="button"
                    role="tab"
                    value={tab.value}
                    aria-selected={reqData.type === tab.value}
                    onClick={() => {
                      if (reqData.type === tab.value) return;
                      setReqData({
                        panelListId: auth.panelistId,
                        type: tab.value,
                      });
                      setCurrentPage(1);
                    }}
                    className="flex-1 whitespace-nowrap sm:flex-none sm:px-4"
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>
            {reqData.type === "approved" && checked ? (
              <button
                className="zs-btn zs-btn-primary zs-btn-sm"
                onClick={() => {
                  navigate("/redeem/form/study", { state: { studyData: claimData } });
                }}
              >
                {t("page.claim.Now")}
                <FiArrowRight />
              </button>
            ) : null}
          </div>

          <div data-testid="survey" className="zs-table-wrap is-flush">
            <table className="zs-table">
              <thead>
                <tr>
                  {reqData.type === "approved" ? <th scope="col" className="w-10"></th> : null}
                  <th scope="col" className="w-12">
                    #
                  </th>
                  <th scope="col">{t("page.claim.Study")}</th>
                  <th scope="col" className="is-num">
                    {t("page.claim.point3")}
                  </th>
                  <th scope="col">{t("page.claim.dates")}</th>
                  {reqData.type === "surveys" ? (
                    <th scope="col">{t("page.claim.action")}</th>
                  ) : (
                    <th scope="col">{t("page.claim.status")}</th>
                  )}
                </tr>
              </thead>
              <tbody data-testid="survey1">
                {getPanelListData.data?.data?.length > 0 ? (
                  getPanelListData.data?.data?.map((survey: Survey, i: number) => {
                    return (
                      <tr key={i}>
                        {reqData.type === "approved" && (
                          <td>
                            <input
                              id="terms"
                              name="terms"
                              type="checkbox"
                              checked={checked}
                              onChange={() => {
                                {
                                  handleCheckboxChange;
                                }
                                setChecked(!checked);
                                setClaimData((prevState) => [
                                  ...prevState,
                                  {
                                    points: survey.points,
                                    studyId: survey.sid,
                                    claimedStudyId: survey.id,
                                    p_id: survey.p_id,
                                  },
                                ]);
                              }}
                              className="w-4 h-4 rounded cursor-pointer accent-primary"
                            />
                          </td>
                        )}
                        <td className="tabular-nums text-ink-3">{i + 1}</td>
                        <td className="is-strong max-w-[320px] truncate" title={survey.studyName}>
                          {survey.studyName}
                        </td>
                        <td className="is-num is-strong">
                          {survey.points ? points(survey.points, 0) : points(0, survey.vendorCpi)}
                        </td>
                        <td className="whitespace-nowrap text-ink-3">{survey.createdAt}</td>
                        <td>
                          <button className="inline-flex flex-col items-start text-left">
                            {btnNeeded(survey, reqData.type)}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={columnCount} className="!p-0">
                      <EmptyState icon={<FiClipboard />} title={t("page.mysurvey.nodata")} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="zs-table-footer justify-center sm:justify-end">
            <Pagination
              setCurrentPage={setCurrentPage}
              totalPages={getPanelListData?.data?.totalPages}
              currentPage={currentPage}
            />
          </div>
        </Card>
      </div>
    </LoadingOverlay>
  );
};
